import { Pipe, PipeTransform } from "@angular/core";

@Pipe({
  name: "listFormatter",
  standalone: true,
  pure: true, // Important: mark as pure for performance
})
export class ListFormatterPipe implements PipeTransform {
  transform(values: string[], style: string, type: string): string {
    if (!values || values.length === 0) {
      return "";
    }
    const formatter = new (Intl as any).ListFormat("es", { style, type });
    return formatter.format(values);
  }
}
